import { getPrice } from '@sigma-frontend-libs/commons'

import { services } from '@/utils'

import render from './render'

const groupOrder = [ 'range', 'packet' ]
const packetFieldOrder = [ 'size', 'spent', 'counter' ]
const rangeFieldOrder = [ 'threshold', 'segmentCount', 'segmentPrice' ]

function resolveType(value) {
  if (value?.type === 'packet') {
    return 'packet'
  }

  return 'range'
}

export default {
  name: 'BillingsPriceCalculation',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    hasGroups() {
      return this.groups.length > 0
    },

    groups() {
      const priceCalculation = this.value?.data?.priceCalculation
      if (!Array.isArray(priceCalculation)) {
        return []
      }

      const groupsMap = {
        packet: [],
        range: []
      }

      for (const item of priceCalculation) {
        if (!item || typeof item !== 'object') {
          continue
        }

        const type = resolveType(item)
        groupsMap[type].push(this.getGroupRow(item, type))
      }

      return groupOrder.reduce((result, type) => {
        const rows = groupsMap[type]
        if (rows.length > 0) {
          result.push({
            key: type,
            rows,
            total: getPrice(this.getGroupTotal(rows)),
            totalTitle: this.getTranslate(`${services.billings}.labels.data.priceCalculation.sum`)
          })
        }

        return result
      }, [])
    }
  },

  methods: {
    getTypeLabel(type) {
      return this.getTranslate(`${services.billings}.labels.data.priceCalculation.types.${type}`)
    },

    getField(field, value) {
      return {
        key: field,
        label: this.getTranslate(`${services.billings}.labels.data.priceCalculation.${field}`),
        value: value ?? ''
      }
    },

    getNumericValue(value) {
      const numericValue = parseFloat(value)
      if (isNaN(numericValue)) {
        return 0
      }

      return numericValue
    },

    getGroupTotal(rows) {
      return rows.reduce((result, { rawAmount }) => {
        return result + rawAmount
      }, 0)
    },

    getPacketFields(item) {
      return packetFieldOrder.map(field => {
        return this.getField(field, item[field])
      })
    },

    getRangeFields(item) {
      return rangeFieldOrder.map(field => {
        let value = item[field]
        if (field === 'segmentPrice') {
          value = getPrice(item[field])
        }

        return this.getField(field, value)
      })
    },

    getGroupRow(item, type) {
      if (type === 'packet') {
        return {
          amount: getPrice(item.price),
          fields: this.getPacketFields(item),
          typeLabel: this.getTypeLabel(type),
          rawAmount: this.getNumericValue(item.price)
        }
      }

      return {
        amount: getPrice(item.sum),
        fields: this.getRangeFields(item),
        typeLabel: this.getTypeLabel(type),
        rawAmount: this.getNumericValue(item.sum)
      }
    }
  },

  render
}
